import { defineComponent as _defineComponent } from 'vue'
import {getVarietisList, getHotVarietisList} from '@/api/miscellaneous';
import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VarietiesTreeSelector',
  emits: ['confirm'],
  setup(__props, { expose, emit }) {
  expose();



const getListData = ref({
    page: 1,
    size: 50,
    id: '',
});
const activeIndex = ref(0);
const list = ref<any[]>([]);
const hotList = ref<any[]>([]);
const loading = ref(false);
const finished = ref(false);

const getList = () => {
    getHotVarietisList().then((res: any) => {
        hotList.value = res;
    });

    getVarietisList({
        page: 1,
        size: 50,
        id: '',
    }).then((res: any) => {
        (res.items as any[]).unshift({value: '全部', key: ''});
        list.value = res.items.map((el: {value: any; key: any}) => ({text: el.value, id: el.key}));
    });
};
getList();

const searchVarietis = (idx: number) => {
    if (loading.value) return;
    loading.value = true;
    getVarietisList(getListData.value).then((res: any) => {
        loading.value = false;
        getListData.value.page += 1;
        list.value[activeIndex.value].children = [...(list.value[activeIndex.value].children || []), ...res.items];
        finished.value = res.count == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
    });
};
const clickNav = (idx: number) => {
    getListData.value.id = list.value[idx].id;
    searchVarietis(idx);
};

const confirm = (id: string, name: string) => {
    emit('confirm', id, name || list.value[activeIndex.value].text);
};

const __returned__ = { emit, getListData, activeIndex, list, hotList, loading, finished, getList, searchVarietis, clickNav, confirm, getVarietisList, getHotVarietisList, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})